import React from 'react';
import { customerShape } from 'constants/propTypes';
import { FormattedMessage } from 'react-intl';
import { CustomerDetailsCell, CustomerDetailsLabel, CustomerDetailsTable } from './CustomerDetails.styles';
import countries from '../../../constants/countries';

const CustomerDetails = ({ customer }) => {
  const getName = () => {
    if (customer?.companyName) {
      return customer.companyName;
    }

    return customer?.firstName ? `${customer?.firstName} ${customer?.lastName}` : '';
  };

  const getCountry = (cc) => {
    if (!cc) {
      return '';
    }

    return countries.find((c) => c.code === cc)?.name;
  };

  const getAddress = () => {
    const address = customer?.address;

    if (!address) {
      return '';
    }

    const cc = address.countryCode;
    const keys = ['street', 'city', 'postalCode'];
    const values = [];

    keys.forEach((k) => address[k] && values.push(address[k]));

    const country = getCountry(cc);

    if (country !== '') {
      values.push(country);
    }

    return values.join(', ');
  };

  const { email, unformattedPhoneNumber } = customer || {};

  return (
    <CustomerDetailsTable>
      <CustomerDetailsLabel data-testid="labelCell">
        <FormattedMessage id="billingDetailsForm.name" />
      </CustomerDetailsLabel>
      <CustomerDetailsCell data-testid="detailCell">{getName()}</CustomerDetailsCell>
      <CustomerDetailsLabel data-testid="labelCell">
        <FormattedMessage id="billingDetailsForm.email" />
      </CustomerDetailsLabel>
      <CustomerDetailsCell data-testid="detailCell">{email}</CustomerDetailsCell>
      <CustomerDetailsLabel data-testid="labelCell">
        <FormattedMessage id="billingDetailsForm.phoneNumber" />
      </CustomerDetailsLabel>
      <CustomerDetailsCell data-testid="detailCell">{`${unformattedPhoneNumber?.countryCode?.replace('+', '') || ''}${
        unformattedPhoneNumber?.number || ''
      }`}</CustomerDetailsCell>
      <CustomerDetailsLabel data-testid="labelCell">
        <FormattedMessage id="billingDetailsForm.address" />
      </CustomerDetailsLabel>
      <CustomerDetailsCell data-testid="detailCell">{getAddress()}</CustomerDetailsCell>
    </CustomerDetailsTable>
  );
};

CustomerDetails.propTypes = {
  customer: customerShape
};

export default CustomerDetails;
